// extracted by mini-css-extract-plugin
export default {"versionModal":"VersionModal_versionModal__sgB2Y","subtitle":"VersionModal_subtitle__zWOtt","symbol":"VersionModal_symbol__QF+WM","bulletList":"VersionModal_bulletList__3Y3e0"};